import * as React from 'react';
import { Button } from '@grandvisionhq/common';

const CallToAction = ({ formId , label , isLoading , isSmallScreen , onClick ,  })=>/*#__PURE__*/ React.createElement(Button, {
        type: "submit",
        "data-t": "cta-button",
        caption: label,
        form: formId,
        isLoading: isLoading,
        size: isSmallScreen ? 'custom' : 'medium',
        className: "configurator-footer-cta",
        onClick: onClick
    })
;

export { CallToAction };
//# sourceMappingURL=CallToAction.js.map
